import { useGoogleAccessToken } from "./useGoogleAccessToken";

export function useGoogleIsAuthenticated() {
    const { accessToken, isLoading, ...rest } = useGoogleAccessToken()

    if (isLoading) {
        return {
            ...rest,
            isLoading: true,
            data: {
                authenticated: false,
            },
        }
    }

    if (accessToken) {
        return {
            ...rest,
            isLoading: false,
            data: {
                authenticated: true,
            },
        }
    }
    return {
        ...rest,
        isLoading: false,
        data: {
            authenticated: false,
            error: {
                message: "Check failed",
                name: "Not Google authenticated",
            }
        }
    };
}